import script from "./ResponseAlert.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResponseAlert.vue?vue&type=script&lang=ts&setup=true"

import "./ResponseAlert.vue?vue&type=style&index=0&id=26a7d3fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26a7d3fe"]])

export default __exports__